import React from "react";
import styles from "./styles.module.scss";
import deleteImg from "../../../shared/images/delete.svg";
import edit from "../../../shared/images/edit.svg";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";

const UserCard = (props) => {
  const { user, header, selectUser, changeStatus, sendCode } = props;

  const editUser = () => {
    selectUser(user.id);
    changeStatus("edit");
  };

  const deleteUser = () => {
    selectUser(user.id);
    changeStatus("delete");
  };
  return (
    <div className={`${header ? styles.userHeader : styles.userContainer}`}>
      <div className={styles.column}>{user.id}</div>
      <div className={styles.column}>{user.name}</div>
      <div className={styles.column}>{user.last_name}</div>
      <div className={styles.column}>{user.email}</div>
      <div className={styles.column}>{user.role}</div>
      <div className={styles.column}>{user.accountType}</div>
      <div className={styles.column}>
        {!header && user.is_verified ? (
          "Verified"
        ) : header ? (
          user.is_verified
        ) : (
          <button
            className={themeStyles.btnActive}
            onClick={() => sendCode(user)}
          >
            Send Code
          </button>
        )}
      </div>
      <div className={styles.buttons}>
        <img
          src={edit}
          alt="edit"
          style={{ marginRight: "20px" }}
          onClick={editUser}
        />
        <img src={deleteImg} alt="delete" onClick={deleteUser} />
      </div>
    </div>
  );
};
export default UserCard;
